import React from 'react';
import { useParams, Navigate } from 'react-router';
import { CrudPage } from '@/components/shared/crud-page';
import { CRUD_CONFIGS } from './configs';
import { DispatchGroupsPage } from './dispatch-groups-page';

export function MasterDataPage() {
  const { entity } = useParams<{ entity: string }>();
  if (!entity || !CRUD_CONFIGS[entity]) {
    return <Navigate to="/dashboard" replace />;
  }
  // Dispatch Groups has a custom "Assign Assets" bulk-action dialog on top
  // of the standard CRUD surface. Other entities use the generic CrudPage
  // directly. Add more entries here if another entity needs page-managed UI.
  if (entity === 'dispatch-groups') return <DispatchGroupsPage />;
  return <CrudPage config={CRUD_CONFIGS[entity]} />;
}
